export default "__VITE_ASSET__1cb72509__"